import { FC } from 'react'
import { useIntl } from 'react-intl'

import { PatientsAPI } from '@api/patientsAPI'

import { initialQueryState } from '@models/apiBase'
import { ID } from '@models/base'
import { Option } from '@models/option'

import { AsyncPaginateSelectField, AsyncPaginateSelectFieldProps } from '@components/Form/AsyncPaginateSelect'

import { ReactSelectPatientOption } from '@modules/patients/components/ReactSelectPatientOption'

import TypeUtil from '@/utils/typeUtil'

type Props = Omit<AsyncPaginateSelectFieldProps<false>, 'onSearch'> & {
  patientId: ID
}

const PartientRelativeFormPatientSelectField: FC<Props> = ({ patientId, ...props }) => {
  const intl = useIntl()

  const searchDebounce = async (keyword: string) => {
    const response = await PatientsAPI.getOptionsForPatientRelativeForm({
      ...initialQueryState,
      patient_id: patientId,
      phrase: !TypeUtil.isEmpty(keyword) ? keyword : undefined,
    })

    if (response.data) {
      return {
        ...response.data,
        nodes: response.data.nodes.map((patient) => {
          return new Option({
            label: `#${patient.patient_id} - ${patient.full_name}`,
            value: patient.id,
            data: patient,
          })
        }),
      }
    }
  }

  return (
    <AsyncPaginateSelectField
      {...props}
      onSearch={searchDebounce}
      components={{
        Option: ReactSelectPatientOption,
      }}
      noOptionsMessage={() => {
        return intl.formatMessage({
          id: 'patient_visit.form_patient_input_not_found',
        })
      }}
    />
  )
}

export { PartientRelativeFormPatientSelectField }
